<template>
  <div>
    <oil-cap
      title='Импортеры'
      :buttons="[{name:'СОЗДАТЬ ИМПОРТЕРА',route:'importer-create'}]"
    />
    <v-divider class='my-2' />
    <oil-table
      :keys='keys'
      :items='importers'
      :paginate='count'
      @paginateAction='paginate'
    >
      <template v-slot:Status='{value}'>
        <v-chip color='success' v-text='value' />
      </template>
      <template v-slot:Id='{value}'>
        <v-tooltip bottom>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn v-bind='attrs'
                   v-on='on' icon
                   @click.stop='rowClick(value)'>
              <v-icon color='primary'>
                mdi-pen
              </v-icon>
            </v-btn>
          </template>
          <span>РЕДАКТИ́РОВАТЬ</span>
        </v-tooltip>
      </template>
      <template v-slot:DeleteId='{value}'>
        <v-row>
          <v-col
            md='4'
            offset-md='4'
          >
            <oil-modal
              :value='value'
              tooltipMessage='УДАЛИТЬ'
              mdiIcon='mdi-delete'
              :accept='accept'
            />
          </v-col>
        </v-row>

      </template>
    </oil-table>

  </div>

</template>

<script>

import { coreApi } from '~/services/core'
import { productsService } from '~/services/ProductsService'

export default {
  components: {
    OilCap: () => import('@/components/helper/oil.cap'),
    OilTable: () => import('@/components/helper/oil.table'),
    OilModal: () => import('@/components/helper/form/oil.delete.modal')

  },
  data: () => ({
    keys: [
      {
        text: 'Название',
        value: 'Name'
      },
      {
        text: 'Контракт',
        value: 'Contract'
      },
      {
        text: 'Адрес',
        value: 'Address'
      },
      {
        text: '',
        value: 'Id'
      },
      {
        text: '',
        value: 'DeleteId'
      }
    ],
    importers: [],
    count: {
      count: 0
    }
  }),
  async created() {
    await this.paginate((this.currentPage - 1) * 10)
    // const response = await coreApi.get('importer')
    //
    // this.importers = response.data?.map(importer => {
    //   return {
    //     Id: importer.Id,
    //     Name: importer.Name,
    //     Contract: importer?.Contracts?.map(({Number}) => Number).join(','),
    //     Address: importer.Address,
    //     DeleteId: importer.Id
    //   }
    // })
  },
  methods: {
    async rowClick(Id) {
      await this.$router.push({
        name: 'importer-create',
        params: { id: Id }
      })
    },

    async paginate(page) {
      const importers = await coreApi.get(`importer/${page}`)
      const { count, dates } = importers.data
      this.count.count = count
      this.importers = dates?.map(importer => {
        return {
          Id: importer.Id,
          Name: importer.Name,
          Contract: importer?.Contracts?.map(({ Number }) => Number).join(','),
          Address: importer.Address,
          DeleteId: importer.Id
        }
      }) || []
    },
    async accept(id) {
      const isDelete = await coreApi.delete(`importer?id=${id}`)
      if (isDelete.data) {
        const product = this.importers.find(({ Id }) => Id === id)
        const index = this.importers.indexOf(product)
        this.importers.splice(index, 1)
        this.$notify({
          group: 'mgs',
          type: 'success',
          title: 'удачно удален'
        })
      }
    },
    async mockData() {

      return new Promise((resolve, reject) => {
        const tmp = [
          {
            Id: '',
            Name: 'OOO "Uzgazoil"',
            Contract: '1',
            Address: 'г. Ташкент мирабадский район улица Темур дом 1',
            Status: 'Активный'
          },
          {
            Id: '',
            Name: 'ИП OOO "Neft"',
            Contract: '2',
            Address: 'Наманганская область туракопган КФЙ ул Азимов дом 7',
            Status: 'Активный'
          },
          {
            Id: '',
            Name: 'OOO "Green"',
            Contract: '3',
            Address: 'Ферганская область кичик халка КФЙ ул Амир темур дом 11',
            Status: 'Активный'
          },
          {
            Id: '',
            Name: 'CGP "Best"',
            Contract: '4',
            Address: 'Ташкентская область Юкори Чирчикский район ул Ауэзова дом 55',
            Status: 'Активный'
          }
        ]
        setTimeout(() => {
          resolve(tmp)
        }, 500)

      })
    }
  }


}
</script>
